<template>
  <div>
    <Slidercards />

    <router-view></router-view>
  </div>
</template>

<script>
import Slidercards from "./components/Slidercards.vue";

export default {
  components: {
    Slidercards,
  },
};
</script>
